import { ZonedDateTime } from '@js-joda/core';

/**
 * Applies an edited wall-clock time (and optional date) to an event timestamp,
 * interpreting the wall-clock in the zone offset carried by the timestamp
 * itself (the hospital's), never the browser's. Seconds are preserved from the
 * original. Returns a JS Date so callers keep the existing mutation wire shape.
 */
export const applyEditedWallClock = (timestamp: string, time: string, date?: string): Date => {
  let zdt = ZonedDateTime.parse(timestamp);
  if (date) {
    const [year, month, day] = date.split('-').map(part => parseInt(part, 10));
    if (isFinite(year) && isFinite(month) && isFinite(day)) {
      zdt = zdt.withYear(year).withMonth(month).withDayOfMonth(day);
    }
  }
  const [hours, minutes] = time.split(':').map(part => parseInt(part, 10));
  zdt = zdt.withHour(hours).withMinute(minutes);
  return new Date(zdt.toInstant().toEpochMilli());
};
